import { Routes } from '@angular/router';
import { SolErrorRoutePageComponent } from '@sol/components';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'error',
    component: SolErrorRoutePageComponent,
  },
];
